import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { useWorkspaceClientName } from "../../OrganizationCloseTemplates/useWorkspaceClientName";
import type { OrganizationTaskTemplateRow } from "../organizationTaskTemplatesViewConfig";
import { getOrganizationTaskTemplatesTableMeta } from "../organizationTaskTemplatesTableMeta";

const ALL_CLIENTS_LABEL = "All clients";

export const OrganizationTaskTemplateClientCell = memo(
    function OrganizationTaskTemplateClientCell({
        row,
        table,
    }: CellContext<ViewTableFeatures, OrganizationTaskTemplateRow, string>) {
        const meta = getOrganizationTaskTemplatesTableMeta(table);
        const template = meta?.templatesById.get(row.original.id);
        const workspaceName = useWorkspaceClientName(template?.workspaceId);

        return (
            <ViewTableCell>
                <span className="text-secondary">
                    {template?.workspaceId
                        ? (workspaceName ?? "-")
                        : ALL_CLIENTS_LABEL}
                </span>
            </ViewTableCell>
        );
    },
);
